export default [
  {
    key: 'raptor',
    name: 'Philosoraptor',
    url: "https://i.imgflip.com/2dni2e.jpg",
    emoji: "🦖"
  },
  {
    key: 'spongebobrainbow',
    name: 'Sponge Bob',
    url: "https://imgflip.com/s/meme/Imagination-Spongebob.jpg",
    emoji: "🛁"
  },
  {
    key: 'yangcoffee',
    name: 'Andrew Yang',
    url:  "https://i.imgflip.com/32zp1n.png?a435480",
    emoji: "☕️"
  },
  {
    key: 'zoidberg',
    name: 'Zoidberg',
    url: 'https://imgflip.com/s/meme/Futurama-Zoidberg.jpg',
    emoji: "🦀"
  },
  {
    key: 'kermittea',
    name: 'Kermit',
    url: 'https://sm.mashable.com/t/mashable_in/photo/default/we-ein-gut-tass-te-z-schtze-kermi-de-frosc-89072_4d49.910.jpg',
    emoji: "🐸"
  }
]

